import { Component, OnInit, ViewContainerRef, PLATFORM_ID, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';

import { AuthService } from './shared';
import { ServiceWorkerService } from './sw.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor (
    private authService: AuthService,
    private translate: TranslateService,
    public vcr: ViewContainerRef,
    private sWService: ServiceWorkerService,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    translate.addLangs(['en', 'fr']);
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
  }

  ngOnInit() {
    this.authService.populate();
    if (isPlatformBrowser(this.platformId)) {
      this.sWService.checkForUpdates();
    }
  }

}
